module.exports = __webpack_public_path__ + "static/extensionView-80bd04036503e9c18daff7a14ad8722c.png";